/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getDiscoveryServer} from '../api'

 export const useQueryGetDiscoveryServer = createReactQueryHook('getDiscoveryServer', getDiscoveryServer)
